import React from "react";
import "../../../styles/MailTemplateViewPage.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import MailHeader from "../MailHeader";
import back_arrow from "../../../assets/svg/back-arrow.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axiosInstance from "../../../axiosInstance";
import { useEffect, useState } from "react";


const MailTemplateViewPage = () => {
    const navigate = useNavigate();
    const [attachments, setAttachments] = useState([]);
    const location = useLocation();
    const rowId = location.state?.rowId;

    const [row, setRow] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!rowId) return;

        const fetchViewPageTemplate = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get(
                    `/mail_template/edit/${rowId}`
                );
                setRow(response.data.Mail_template);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchViewPageTemplate();
    }, [rowId]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!row) {
        return <div>No data found</div>;
    }

    const formattedContent = row.content
        .replace(/\[#user]/g, "John Doe")
        .replace(/\[#code]/g, "123456")
        .replace(/\[#support_email]/g, "support@mawalog.com")
        .replace(/\[#support_contact1]/g, "+91 98765 43210")
        .replace(/\[#support_contact2]/g, "044-12345678");


    return (
        <>
            <MailHeader />

            {/* Header */}
            <div className="invoice-module-header">
                <div className="invoice-module-header-left">
                    <img
                        src={back_arrow}
                        alt="Back"
                        onClick={() => navigate(-1)}
                        style={{ cursor: "pointer" }}
                    />
                    <p className="new_job" style={{ fontSize: "14px" }}>
                        Mail Template View Page
                    </p>
                </div>

                {/* <div className="invoice-module_header_right">
                    <button className="edit_btn" onClick={() => navigate(-1)}>
                        Cancel
                    </button>
                </div> */}
            </div>

            {/* View Page Body */}
            <div className="mail-template-viewpage">
                <div className="mail-template-viewpage-content">

                    {/* Template Details */}
                    <h3 className="mail-template-viewpage-section-title">
                        Template details
                    </h3>

                    <div className="mail-template-viewpage-details">
                        <div className="mail-template-viewpage-row">
                            <span className="mail-template-viewpage-label">Title</span>
                            <span className="mail-template-viewpage-value">{row.title}</span>
                        </div>

                        <div className="mail-template-viewpage-row">
                            <span className="mail-template-viewpage-label">Subject</span>
                            <span className="mail-template-viewpage-value">{row.subject}</span>
                        </div>

                        <div className="mail-template-viewpage-row">
                            <span className="mail-template-viewpage-label">CC</span>
                            <div className="mail-template-viewpage-email-list">
                                {row.cc_email
                                    ? row.cc_email.split(",").map((email, index) => (
                                        <span key={index} className="mail-template-viewpage-email-pill">
                                            {email.trim()}
                                        </span>
                                    ))
                                    : "-"}
                            </div>
                        </div>

                        <div className="mail-template-viewpage-row">
                            <span className="mail-template-viewpage-label">BCC</span>
                            <div className="mail-template-viewpage-email-list">
                                {row.bcc_email
                                    ? row.bcc_email.split(",").map((email, index) => (
                                        <span key={index} className="mail-template-viewpage-email-pill">
                                            {email.trim()}
                                        </span>
                                    ))
                                    : "-"}
                            </div>
                        </div>

                        <div className="mail-template-viewpage-row">
                            <span className="mail-template-viewpage-label">Status</span>
                            <span
                                className={`mail-template-viewpage-status ${row.status
                                    ? "mail-template-viewpage-status-active"
                                    : "mail-template-viewpage-status-inactive"
                                    }`}
                            >
                                <span className="mail-template-viewpage-status-dot" />
                                {row.status ? "Active" : "Inactive"}
                            </span>
                        </div>
                    </div>

                    <hr className="mail-template-viewpage-divider" />

                    {/* Message */}
                    <h3 className="mail-template-viewpage-section-title">Message</h3>

                    <div
                        className="mail-template-viewpage-message-card"
                        dangerouslySetInnerHTML={{ __html: formattedContent }}
                    ></div>

                    {/* Attachments */}
                    {attachments.length > 0 && (
                        <div className="mail-template-viewpage-attachments">
                            <p className="mail-template-viewpage-attachments-title">
                                Attachments
                            </p>

                            <div className="mail-template-viewpage-attachments-list">
                                {attachments.map((file, index) => (
                                    <div
                                        key={index}
                                        className="mail-template-viewpage-attachment-pill"
                                    >
                                        📎 {file.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <CommonFooter />
            <ToastContainer position="top-right" autoClose={3000} />
        </>
    );
};

export default MailTemplateViewPage;
